import consumer from "./consumer";

let subscription = null;

export function subscribeToAgentJob(jobId, callbacks = {}) {
  unsubscribeFromAgentJob();

  subscription = consumer.subscriptions.create(
    { channel: "AgentJobChannel", job_id: jobId },
    {
      received(data) {
        if (data.type === "new_message" && callbacks.onMessage) {
          callbacks.onMessage(data);
        }
        if (data.type === "message_update" && callbacks.onMessageUpdate) {
          callbacks.onMessageUpdate(data);
        }
        if (data.type === "token_update" && callbacks.onTokenUpdate) {
          callbacks.onTokenUpdate(data.tokens_used);
        }
        if (data.type === "status_update" && callbacks.onStatusUpdate) {
          callbacks.onStatusUpdate(data.status);
        }
      }
    }
  );
}

export function unsubscribeFromAgentJob() {
  if (subscription) {
    subscription.unsubscribe();
    subscription = null;
  }
}
